/**
 * SWS Custom JavaScript
 * Handles AJAX add-to-cart, scroll reveals, counter animations,
 * trust bar icon pulse, and newsletter button text swap.
 */
(function() {
  'use strict';

  /* ============================================
     1. AJAX Add-to-Cart (Horizon theme integration)
     ============================================ */
  function initAddToCart() {
    document.querySelectorAll('.sws-product-form').forEach(function(form) {
      if (form.dataset.swsInit) return;
      form.dataset.swsInit = 'true';

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(form);
        var submitBtn = form.querySelector('[type="submit"]');
        if (!submitBtn || submitBtn.disabled) return;

        var originalText = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function(item) {
          submitBtn.innerHTML = 'Added \u2713';

          return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            var event = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: form.id || 'sws-product-form',
                data: {
                  source: 'sws-custom',
                  itemCount: cart.item_count,
                  variantId: String(item.variant_id)
                }
              }
            });
            document.dispatchEvent(event);

            setTimeout(function() {
              submitBtn.innerHTML = originalText;
              submitBtn.disabled = false;
            }, 2000);
          });
        })
        .catch(function(err) {
          console.error('SWS Add to cart error:', err);
          submitBtn.innerHTML = 'Error - Try Again';
          setTimeout(function() {
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }, 2000);
        });
      });
    });
  }

  /* ============================================
     2. Scroll Reveal (IntersectionObserver)
     ============================================ */
  function initScrollReveal() {
    var revealEls = document.querySelectorAll('.sws-reveal');
    if (!revealEls.length || !('IntersectionObserver' in window)) {
      // Fallback: just show everything
      revealEls.forEach(function(el) { el.classList.add('sws-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sws-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    revealEls.forEach(function(el) {
      observer.observe(el);
    });
  }

  /* ============================================
     3. Counter Animation
     Animates elements with [data-sws-counter]
     from 0 to their text content value.
     ============================================ */
  function initCounters() {
    var counterEls = document.querySelectorAll('[data-sws-counter]');
    if (!counterEls.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    counterEls.forEach(function(el) {
      observer.observe(el);
    });
  }

  function animateCounter(el) {
    var text = el.textContent.trim();
    // Extract numeric value — handle formats like "$115", "21", "$115/month", "5g"
    var match = text.match(/([\$]?)(\d+)(.*)/);
    if (!match) return;

    var prefix = match[1];
    var target = parseInt(match[2], 10);
    var suffix = match[3];
    var duration = 1500;
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * target);
      el.textContent = prefix + current + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = prefix + target + suffix;
      }
    }

    requestAnimationFrame(step);
  }

  /* ============================================
     4. Trust Bar Icon Pulse
     Staggered scale animation on scroll into view.
     ============================================ */
  function initTrustBarPulse() {
    var trustBar = document.querySelector('.sws-trust-bar');
    if (!trustBar || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var icons = entry.target.querySelectorAll('.sws-trust-bar__icon');
          icons.forEach(function(icon, i) {
            setTimeout(function() {
              icon.style.transition = 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)';
              icon.style.transform = 'scale(1.3)';
              setTimeout(function() {
                icon.style.transform = 'scale(1)';
              }, 200);
            }, i * 120);
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    observer.observe(trustBar);
  }

  /* ============================================
     5. Newsletter Button Text Swap
     On hover: "Subscribe" → "Join the Squad →"
     ============================================ */
  function initNewsletterSwap() {
    var btns = document.querySelectorAll('.sws-newsletter__submit');
    btns.forEach(function(btn) {
      if (btn.dataset.swsSwapInit) return;
      btn.dataset.swsSwapInit = 'true';

      var original = btn.textContent.trim();
      var hoverText = btn.getAttribute('data-sws-hover-text') || 'Join the Squad \u2192';

      btn.addEventListener('mouseenter', function() {
        btn.textContent = hoverText;
      });
      btn.addEventListener('mouseleave', function() {
        btn.textContent = original;
      });
    });
  }

  /* ============================================
     Init Everything
     ============================================ */
  function initAll() {
    initAddToCart();
    initScrollReveal();
    initCounters();
    initTrustBarPulse();
    initNewsletterSwap();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor loads sections
  document.addEventListener('shopify:section:load', function() {
    initAll();
  });
})();
